import { Component, OnInit } from '@angular/core';
import { ESG } from '../../interfaces/esg.interfaces';

import { EsgService } from '../../sevices/esg.service';
import { EsgJson } from './esg.json';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-esg',
  templateUrl: './esg.component.html',
  styleUrls: ['./esg.component.css']
})
export class EsgComponent implements OnInit {

  esgData: any;
  isDataLoaded: boolean = false;

  // EsgJson: ESG = EsgJson;

  constructor(private esgService: EsgService, private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => { });

    this.esgService.getEsg().subscribe({
      next: (resp) => {
        this.esgData = resp.data;
        // console.log(this.esgData)
        this.esgData.parallaxImgUrl = "https://" + this.esgData.parallaxImgUrl;


        this.isDataLoaded = true;
      },
      error: (error) => {
        console.log(error)
      }
    })

  }

  ngOnInit(): void {


  }
  get backgroundImageUrl() {
    return `url(${this.esgData.parallaxImgUrl})`;
  }
}
